/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Global_Product_Family_Enum =
  | 'ALL'
  | 'NONE';

export type Product_Family_Name_Enum =
  | 'BEVERAGES'
  | 'FRESH_FOOD'
  | 'GROCERY'
  | 'NON_FOOD_PRODUCTS';

export type Product_Sub_Family_Name_Enum =
  | 'BAKERY'
  | 'BEER_CIDER'
  | 'CLOTHING_TEXTILE'
  | 'DAIRY'
  | 'DELI'
  | 'FISH_SEAFOOD'
  | 'FLORAL'
  | 'FROZEN_FOOD'
  | 'FRUITS'
  /**   */
  | 'GAMES_TOYS'
  | 'HOUSEHOLD_CLEANING'
  | 'HYGIENE_BEAUTY'
  | 'NON_ALCOHOLIC_BEVERAGES'
  | 'PETS'
  | 'RAW_MEAT'
  | 'SALTY_GROCERY'
  | 'SPIRITS'
  | 'SWEET_GROCERY'
  | 'VEGETABLES'
  | 'VEGETARIAN_VEGAN'
  | 'WINE_CHAMPAGNE_SPARKLING';

export type CompanyContactInfoQueryVariables = Exact<{
  buyingCompanyId: string;
  supplyingCompanyId: string;
}>;


export type CompanyContactInfoQuery = { buyingCompany: { role_assignments: Array<{ id: string, user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null }, product_families: Array<{ product_family: Types.Product_Family_Name_Enum | null, global_setting: Types.Global_Product_Family_Enum | null, product_sub_family: Types.Product_Sub_Family_Name_Enum | null }> }> } | null, supplyingCompany: { products: Array<{ sub_family: string }> } | null };


export const CompanyContactInfoDocument = /*#__PURE__*/ gql`
    query CompanyContactInfo($buyingCompanyId: uuid!, $supplyingCompanyId: uuid!) {
  buyingCompany: company_by_pk(id: $buyingCompanyId) {
    role_assignments(where: {role_name: {_neq: COMPANY_ADMIN}}) {
      id
      user {
        ...userFragment
      }
      product_families {
        product_family
        global_setting
        product_sub_family
      }
    }
  }
  supplyingCompany: company_by_pk(id: $supplyingCompanyId) {
    products(distinct_on: sub_family) {
      sub_family
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCompanyContactInfoQuery__
 *
 * To run a query within a React component, call `useCompanyContactInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactInfoQuery({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *   },
 * });
 */
export function useCompanyContactInfoQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactInfoQuery, CompanyContactInfoQueryVariables> & ({ variables: CompanyContactInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>(CompanyContactInfoDocument, options);
      }
export function useCompanyContactInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>(CompanyContactInfoDocument, options);
        }
// @ts-ignore
export function useCompanyContactInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>;
export function useCompanyContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyContactInfoQuery | undefined, CompanyContactInfoQueryVariables>;
export function useCompanyContactInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>(CompanyContactInfoDocument, options);
        }
export type CompanyContactInfoQueryHookResult = ReturnType<typeof useCompanyContactInfoQuery>;
export type CompanyContactInfoLazyQueryHookResult = ReturnType<typeof useCompanyContactInfoLazyQuery>;
export type CompanyContactInfoSuspenseQueryHookResult = ReturnType<typeof useCompanyContactInfoSuspenseQuery>;
export type CompanyContactInfoQueryResult = Apollo.QueryResult<CompanyContactInfoQuery, CompanyContactInfoQueryVariables>;